import type { ReactNode } from 'react';
import React from 'react';
import type { JSX } from '@gov-design-system-ce/components';
import {
	GovControlGroup,
	GovDropdown,
	GovIcon,
} from '@gov-design-system-ce/react';
import type { Nullable } from '@gov-nx/core/types';
import { is } from '@gov-nx/core/types';
import type { FormButtonProps } from '@gov-nx/ui/web';
import { Button, Icon } from '@gov-nx/ui/web';
import { useGlobalLocale } from '@gov-nx/core/service';

export interface ButtonDropdownProps {
	buttons: Nullable<{
		button: Omit<FormButtonProps, 'isExpanded' | 'type'>;
		icon?: JSX.GovIcon;
		tooltip?: ReactNode;
	}>[];
}

export const ButtonDropdown = (props: ButtonDropdownProps) => {
	const buttons = props.buttons.filter(is);
	const firstButton = buttons[0];
	const { t } = useGlobalLocale();

	if (buttons.length === 1) {
		return (
			<Button
				{...firstButton.button}
				type="solid"
			/>
		);
	}

	return (
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		<GovControlGroup color={firstButton.button.color}>
			<Button
				color={firstButton.button.color}
				size="s"
				type="base"
				onClick={firstButton.button.onClick}
				className="[ lg:hidden! ]">
				{firstButton.button.children}
			</Button>
			<Button
				color={firstButton.button.color}
				size="s"
				type="base"
				onClick={firstButton.button.onClick}
				className="hidden! [ lg:block! ]"
				iconStart={
					firstButton.icon ? (
						<GovIcon
							name={firstButton.icon.name}
							type={firstButton.icon.type}
						/>
					) : null
				}>
				{firstButton.button.children}
			</Button>
			<GovDropdown
				position="right"
				size="s"
				color={firstButton.button.color}
				type="base"
				className="ds-dropdown-top"
				aria-label={t('akce.wcag.otevrit-nabidku')}
				label={
					<Icon
						name="chevron-down"
						type="components"
					/>
				}>
				{buttons.map(({ button, icon }) => (
					<Button
						{...button}
						key={button.children?.toString()}
						isExpanded={true}
						type="base"
						size="s"
						className="button-fixed-width"
						iconStart={icon ? <GovIcon {...icon} /> : null}>
						{button.children}
					</Button>
				))}
			</GovDropdown>
		</GovControlGroup>
	);
};
